<template>
  <div class="upload-invoice-form">
    <el-form 
      ref="uploadForm" 
      :model="form" 
      :rules="rules" 
      label-width="120px"
      class="upload-form">
      
      <!-- 订单基本信息 -->
      <el-card class="form-card">
        <div slot="header">
          <span>订单基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="form.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderSn">
              <el-input v-model="form.orderSn" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="商家名称" prop="merchantName">
              <el-input v-model="form.merchantName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="customerName">
              <el-input v-model="form.customerName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单金额" prop="amount">
              <el-input v-model="form.amount" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息" prop="instrumentInfo">
              <el-input v-model="form.instrumentInfo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="仪器型号" prop="instrumentModel">
              <el-input v-model="form.instrumentModel" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参考价格" prop="referencePrice">
              <el-input v-model="form.referencePrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="实际价格" prop="actualPrice">
              <el-input v-model="form.actualPrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单状态" prop="orderStatus">
              <el-tag :type="getStatusType(form.orderStatus)">{{ getStatusText(form.orderStatus) }}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 发票上传区域 -->
      <el-card class="form-card">
        <div slot="header">
          <span>发票上传</span>
        </div>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="发票文件" prop="files">
              <el-upload
                class="upload-demo"
                action=""
                :http-request="customUpload"
                multiple
                drag
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-error="handleError"
                :before-upload="beforeUpload"
                :show-file-list="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                  支持上传PDF、图片、Excel或压缩包格式文件，每个文件不超过200MB
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 已上传文件列表 -->
        <div class="uploaded-files" v-if="form.files && form.files.length > 0">
          <h3 class="file-list-title">已上传文件</h3>
          <el-table
            :data="form.files"
            style="width: 100%"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="180"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)"
                  style="margin-left: 10px;">下载</el-button>
                <el-button 
                  type="text" 
                  size="small"
                  style="color: #F56C6C; margin-left: 10px;"
                  @click="handleRemoveUploaded(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <!-- 操作按钮 -->
      <div class="form-actions">
        <el-button type="primary" @click="submitForm" :loading="loading">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'UploadInvoiceForm',
  data() {
    return {
      loading: false,
      orderId: '',
      form: {
        orderSn: '',
        projectName: '',
        merchantName: '',
        customerName: '',
        orderStatus: '',
        amount: '0.00',
        files: [],
        instrumentInfo: '',
        instrumentModel: '',
        referencePrice: '0.00',
        actualPrice: '0.00'
      },
      rules: {
        files: [
          { required: true, message: '请上传至少一个发票文件', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.orderId = this.$route.params.id
    this.fetchOrderDetails()
  },
  methods: {
    async fetchOrderDetails() {
      this.loading = true
      try {
        const res = await adminApi.getOrderById(this.orderId)
        if (res) {
          const orderData = res
          this.form = {
            orderSn: orderData.orderSn || '',
            projectName: orderData.projectName || '',
            merchantName: orderData.merchantName || '',
            customerName: orderData.customerName || '',
            orderStatus: orderData.orderStatus || '',
            amount: orderData.actualPrice ? orderData.actualPrice.toFixed(2) : '0.00',
            files: orderData.invoiceFiles || [],
            instrumentInfo: orderData.deviceName || '',
            instrumentModel: orderData.deviceModel || '',
            referencePrice: orderData.guidePrice ? orderData.guidePrice.toFixed(2) : '0.00',
            actualPrice: orderData.actualPrice ? orderData.actualPrice.toFixed(2) : '0.00'
          }
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      } finally {
        this.loading = false
      }
    },
    
    getStatusType(status) {
      const statusMap = {
        'NOT_SHIPPED': 'info',
        'IN_TRANSIT': 'primary',
        'TESTING': 'warning',
        'TESTED': 'success',
        'COMPLETED': 'success',
        'DISPUTE': 'danger',
        'UNSETTLED': 'warning',
        'RETURN': 'info',
        'FORWARD': 'info',
        'CANCEL': 'danger'
      }
      return statusMap[status] || 'info'
    },
    
    getStatusText(status) {
      const statusTextMap = {
        'NOT_SHIPPED': '未邮寄',
        'IN_TRANSIT': '在途',
        'TESTING': '测试中',
        'TESTED': '已测试',
        'DISPUTE': '复测/争议',
        'RETURN': '回寄',
        'FORWARD': '转寄',
        'UNSETTLED': '未结算',
        'COMPLETED': '已完成',
        'CANCEL': '已取消'
      }
      return statusTextMap[status] || status
    },
    
    // 自定义上传
    customUpload({ file }) {
      // 调用上传接口
      adminApi.uploadFile(file, null, (percent) => {
        console.log(`上传进度: ${parseInt(percent)}%`)
      }).then(res => {
        if (res) {
          const fileData = res
          
          // 确保URL是完整的URL
          let fileUrl = fileData.url || fileData.fileUrl
          if (fileUrl && !fileUrl.startsWith('http') && !fileUrl.startsWith('blob:')) {
            fileUrl = adminApi.ApiUrl + (fileUrl.startsWith('/') ? '' : '/') + fileUrl
          }
          
          // 创建文件对象
          const newFile = {
            name: fileData.fileId,
            size: file.size,
            uploadTime: new Date(),
            url: fileUrl,
            fileId: fileData.fileId || fileData.id,
            path: fileData.path || '',
            status: 'success'
          }
          
          // 将文件添加到上传列表
          this.form.files.push(newFile)
          this.$message.success(`文件 ${file.name} 上传成功`)
        } else {
          this.$message.error(`文件 ${file.name} 上传失败，请重试`)
        }
      }).catch(error => {
        console.error('文件上传失败:', error)
        this.$message.error(`文件 ${file.name} 上传失败: ${error.message || '未知错误'}`)
      })
    },
    
    // 验证文件类型和大小
    beforeUpload(file) {
      const isValidType = this.validateFileType(file)
      const isLt200M = file.size / 1024 / 1024 < 200
      
      if (!isValidType) {
        this.$message.error('只能上传PDF、图片、Excel或压缩包格式的文件!')
        return false
      }
      
      if (!isLt200M) {
        this.$message.error('文件大小不能超过200MB!')
        return false
      }
      
      return true
    },
    
    // 验证文件类型
    validateFileType(file) {
      const validTypes = [
        'application/pdf',
        'image/jpeg',
        'image/png',
        'image/gif',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/zip',
        'application/x-zip-compressed',
        'application/x-rar-compressed',
        'application/octet-stream',
        'application/x-7z-compressed'
      ]
      
      // 获取文件扩展名
      const fileName = file.name;
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
      const validExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'xls', 'xlsx', 'zip', 'rar', '7z'];
      
      // 同时检查MIME类型和文件扩展名
      const isValid = validTypes.includes(file.type) || validExtensions.includes(fileExtension);
      
      if (!isValid) {
        console.log('文件类型不允许:', file.type, fileExtension);
      }
      
      return isValid;
    },
    
    // 格式化文件大小
    formatFileSize(size) {
      if (!size) return '0 B'
      
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      let fileSize = size
      
      while (fileSize >= 1024 && index < units.length - 1) {
        fileSize /= 1024
        index++
      }
      
      return `${fileSize.toFixed(2)} ${units[index]}`
    },
    
    // 预览文件
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    
    // 删除文件
    handleRemove(file, fileList) {
      this.form.files = fileList
    },
    
    // 删除已上传文件
    handleRemoveUploaded(index) {
      this.form.files.splice(index, 1)
    },
    
    // 上传出错
    handleError(err) {
      console.error('上传错误:', err)
      this.$message.error('文件上传失败')
    },
    
    // 下载文件
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    
    // 提交表单
    submitForm() {
      this.$refs.uploadForm.validate(async valid => {
        if (valid) {
          this.loading = true
          
          try {
            // 构造文件列表
            const fileList = this.form.files.map(file => ({
              fileId: file.fileId,
              fileName: file.name,
              fileUrl: file.url,
              filePath: file.path || '',
              fileSize: file.size
            }))
            
            // 使用uploadContractAndInvoice接口
            const params = {
              orderSn: this.form.orderSn,
              orderInvoiceFileList: fileList
            }
            
            const res = await adminApi.uploadContractAndInvoice(params)
            
            if (res && (res.code === 200 || res === true)) {
              this.$message.success('发票上传成功')
              
              // 根据当前订单状态决定跳转路径
              if (this.form.orderStatus === 'UNSETTLED') {
                this.$router.push('/admin/orders/unsettled')
              } else if (this.form.orderStatus === 'COMPLETED') {
                this.$router.push('/admin/orders/completed')
              } else {
                this.$router.push('/admin/orders/all')
              }
            } else {
              this.$message.error((res && res.msg) || '发票上传失败')
            }
          } catch (error) {
            console.error('上传发票失败:', error)
            this.$message.error('发票上传失败: ' + (error.message || '未知错误'))
          } finally {
            this.loading = false
          }
        }
      })
    },
    
    // 取消按钮
    cancel() {
      // 根据当前订单状态决定返回路径
      if (this.form.orderStatus === 'UNSETTLED') {
        this.$router.push('/admin/orders/unsettled')
      } else if (this.form.orderStatus === 'COMPLETED') {
        this.$router.push('/admin/orders/completed')
      } else {
        this.$router.push('/admin/orders/all')
      }
    }
  }
}
</script>

<style scoped>
.upload-invoice-form {
  padding: 20px;
}

.form-card {
  margin-bottom: 20px;
}

.form-actions {
  margin-top: 20px;
  text-align: center;
}

.uploaded-files {
  margin: 20px 0;
}

.file-list-title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.upload-demo {
  width: 100%;
}

.upload-demo .el-upload {
  width: 100%;
}

.upload-demo .el-upload-dragger {
  width: 100%;
}
</style> 